__turbopack_context__.v({
  "author": "ForWho-module__CsFfsG__author",
  "authorMeta": "ForWho-module__CsFfsG__authorMeta",
  "authorName": "ForWho-module__CsFfsG__authorName",
  "avatar": "ForWho-module__CsFfsG__avatar",
  "band": "ForWho-module__CsFfsG__band",
  "container": "ForWho-module__CsFfsG__container",
  "photo": "ForWho-module__CsFfsG__photo",
  "quote": "ForWho-module__CsFfsG__quote",
  "quoteHead": "ForWho-module__CsFfsG__quoteHead",
  "quoteText": "ForWho-module__CsFfsG__quoteText",
  "reading": "ForWho-module__CsFfsG__reading",
  "readingBody": "ForWho-module__CsFfsG__readingBody",
  "readingText": "ForWho-module__CsFfsG__readingText",
  "readingTitle": "ForWho-module__CsFfsG__readingTitle",
  "readings": "ForWho-module__CsFfsG__readings",
  "stage": "ForWho-module__CsFfsG__stage",
  "tag": "ForWho-module__CsFfsG__tag",
  "titleLine": "ForWho-module__CsFfsG__titleLine",
});
